/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalBody,
  ModalFooter,
  Button,
  Image,
  Box,
  Center,
} from '@chakra-ui/react';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';

interface FilePreviewProps {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  preview?: File | null | undefined;
  previewUrl?: any | undefined;
}
const FilePreview = ({
  isOpen,
  onClose,
  preview,
  previewUrl,
}: FilePreviewProps) => {
  const [numPages, setNumPages] = useState(1);
  const pageArray: number[] = [];
  for (let i = 1; i <= numPages; i++) {
    pageArray.push(i);
  }
  const onDocumentLoadSuccess = (pages: any) => {
    setNumPages(pages._pdfInfo.numPages);
  };
  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Center pt="10px">Preview</Center>
        </ModalHeader>
        <ModalBody>
          {preview?.type === 'application/pdf' ? (
            <Box mt="20px" position="relative" height="500px" overflow="scroll">
              <Center>
              <Document file={previewUrl} onLoadSuccess={onDocumentLoadSuccess}>
                {pageArray.map((page: any, index: number) => (
                  <Page key={index} pageNumber={page} />
                ))}
              </Document>
              </Center>
            </Box>
          ) : (
            <Box>
              <Center>
                <Image
                  my="20px"
                  maxHeight="500px"
                  rounded="lg"
                  src={previewUrl}
                />
              </Center>
            </Box>
          )}
        </ModalBody>

        <Center>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Close
          </Button>
        </Center>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};
export default FilePreview;
